<template>
  <div class="add-message-modal">
    <div class="div-block-45">
      <div>
        <div class="text-block-33">Select a professional</div>
      </div>
      <div class="div-block-46">
        <form action="/search" class="search-4-copy w-form">
          <input
            type="search"
            class="search-input-3 w-input"
            maxlength="256"
            name="query"
            placeholder="Search…"
            id="search-3"
            required=""
            v-model="searchModel.stringToFind"
            @input="searchProfessionalAction"
          />
          <input
            type="submit"
            value="Search"
            class="search-button-2 w-button"
          />
        </form>
      </div>
      <div class="div-block-49">
        <a
          @click="profile(professional)"
          class="div-block-47 w-inline-block"
          v-for="(professional, index) in professionalList"
          :key="index"
        >
          <div class="div-block-48">
            <img
              :src="
                professional.customerDisplayPicture ||
                  require('@/assets/timeslot-images/profileImg.svg')
              "
              loading="lazy"
              width="50"
              alt=""
              class="image-book"
            />
          </div>

          <div>
            <div class="text-block-34">{{ professional.customerName }}</div>
            <div class="text-block-35">
              {{ professional.professionalSubCategory }}
            </div>
          </div>
        </a>
        <!--        <a href="../customer/professional-profile.html" class="div-block-47 w-inline-block">-->
        <!--          <div class="div-block-48"><img src="@/assets/timeslot-images/user_1user.png" loading="lazy" width="50" alt=""></div>-->
        <!--          <div>-->
        <!--            <div class="text-block-34">Idris Yusuf</div>-->
        <!--            <div class="text-block-35">Product Designer</div>-->
        <!--          </div>-->
        <!--        </a>-->
        <!--        <a href="../customer/professional-profile.html" class="div-block-47 w-inline-block">-->
        <!--          <div class="div-block-48"><img src="@/assets/timeslot-images/user_1user.png" loading="lazy" width="50" alt=""></div>-->
        <!--          <div>-->
        <!--            <div class="text-block-34">Idris Yusuf</div>-->
        <!--            <div class="text-block-35">Product Designer</div>-->
        <!--          </div>-->
        <!--        </a>-->
        <!--        <a href="#" class="div-block-47 w-inline-block">-->
        <!--          <div class="div-block-48"><img src="@/assets/timeslot-images/user_1user.png" loading="lazy" width="50" alt=""></div>-->
        <!--          <div>-->
        <!--            <div class="text-block-34">Idris Yusuf</div>-->
        <!--            <div class="text-block-35">Product Designer</div>-->
        <!--          </div>-->
        <!--        </a>-->
        <!--        <a href="#" class="div-block-47 w-inline-block">-->
        <!--          <div class="div-block-48"><img src="@/assets/timeslot-images/user_1user.png" loading="lazy" width="50" alt=""></div>-->
        <!--          <div>-->
        <!--            <div class="text-block-34">Idris Yusuf</div>-->
        <!--            <div class="text-block-35">Product Designer</div>-->
        <!--          </div>-->
        <!--        </a>-->
        <!--        <a href="#" class="div-block-47 w-inline-block">-->
        <!--          <div class="div-block-48"><img src="@/assets/timeslot-images/user_1user.png" loading="lazy" width="50" alt=""></div>-->
        <!--          <div>-->
        <!--            <div class="text-block-34">Idris Yusuf</div>-->
        <!--            <div class="text-block-35">Product Designer</div>-->
        <!--          </div>-->
        <!--        </a>-->
      </div>
      <div
        data-w-id="30de44a5-a3b1-7c63-9194-7768c3111588"
        @click="cancel"
        class="link-block-5 w-inline-block"
      >
        <img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import ProfessionalRequest from "@/model/requests/ProfessionalRequest";

export default {
  name: "NewBookingModal",
  data() {
    return {
      searchModel: ProfessionalRequest.search
    };
  },
  props: {
    cancel: Function
  },
  computed: {
    ...mapState({
      professionalList: state => state.professional.professionalsDisplay,
      professionalId: state => state.professional.professionalId
    })
  },
  methods: {
    profile(professional) {
      StoreUtils.commit(
        StoreUtils.mutations.professional.SET_PROFESSIONAL,
        professional
      );
      StoreUtils.commit(
        "professional/updateProfessionalId",
        professional.professionalId
      );
      RouterUtils.changeRouteUrlTo(
        `/professionals/${professional.professionalId}`
      );
    },
    searchProfessionalAction() {
      StoreUtils.dispatch("professional/searchProfessional", this.searchModel);
    }
  },
  mounted() {
    StoreUtils.dispatch(StoreUtils.actions.professional.READ_PROFESSIONALS);
  }
};
</script>

<style scoped>
.image-book {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
</style>
